






import { listFactory } from '@/main/pages';
import zakazkaSelect from '@/modules/servis/zakazka/components/Select.vue';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';

import { PROrdersParts } from '@/modules/sklad/PROrders/parts/index';

import { store } from './store/list';
import { NAME, ND_OBJEDNAVKA } from './constants';
import { types } from './store/types';

type ListenerArgs = {
	event: Event;
	data: any;
	mode: PageMode;
};

export default listFactory(NAME, store).extend({
	components: {
		zakazkaSelect,
	},
	computed: {
		mutationsMappers(): Record<string, string> {
			return {
				zakazka: `${this.storeUri}/${types.mutations.ND_OBJEDNAVKA_ZAKAZKA_ZAKAZKA_MAPPER}`,
			};
		},
	},
	methods: {
		createClick() {
			// For India market we have separate PR order screen from there we can order multiple parts for a single order .
			if (this.loggedUser.DmsSys.PROrdersPrp) {
				openEdit(PROrdersParts.name, PageMode.CREATE, { filter: { ZakazkaId: this.ZakazkaId } });
			} else {
				openEdit(ND_OBJEDNAVKA, PageMode.CREATE, { filter: { ZakazkaId: this.ZakazkaId } });
			}
		},
		editClick(args: ListenerArgs) {
			openEdit(ND_OBJEDNAVKA, PageMode.EDIT, { id: args.data.ID });
		},
		viewClick(args: ListenerArgs) {
			openEdit(ND_OBJEDNAVKA, PageMode.VIEW, { id: args.data.ID });
		},
	},
});
